import { render, staticRenderFns } from "./FilesV2.vue?vue&type=template&id=41ea66ea"
import script from "./FilesV2.vue?vue&type=script&lang=js"
export * from "./FilesV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports